import { apiBeta } from 'src/client/api';
import { player } from 'src/client/player';
import { generateUniqueId } from 'src/common/utils/generateUniqueId';

export const SET_PAGE_LOAD_ID = 'SET_PAGE_LOAD_ID';
export const SET_BREADCRUMB_ID = 'SET_BREADCRUMB_ID';

export function setPageLoadId() {
  const pageLoadId = generateUniqueId().toString();

  apiBeta.updateReportingData({ pageLoadId });

  return {
    type: SET_PAGE_LOAD_ID,
    pageLoadId,
  };
}

export function setBreadcrumbId(options) {
  const breadcrumbId = options?.reset ? '' : generateUniqueId().toString();

  apiBeta.updateReportingData({ breadcrumbId });
  player.setAppSessionData({ breadcrumbId });

  return {
    type: SET_BREADCRUMB_ID,
    breadcrumbId,
  };
}
